"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchConfigData = exports.fetchNotificationsData = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _PulseApiHelper = _interopRequireDefault(require("./PulseApiHelper"));

var _PulseUtil = _interopRequireDefault(require("../util/PulseUtil"));

var types = _interopRequireWildcard(require("../store/actions/actionTypes"));

var Constants = _interopRequireWildcard(require("../constants/Constants"));

var _metrics = _interopRequireDefault(require("@adobe/exc-app/metrics"));

var NotificationsSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var _NotificationConfigParser = _interopRequireDefault(require("./NotificationConfigParser"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var instance;

var metrics = function metrics() {
  return instance || (instance = _metrics.default.create('exc.pulse.NotificationPolling'));
};
/*
  * fetchNotificationsData(store, fetchFilters = false) is to make the call to ANS API
  * fetchFilters is a boolean which when true, fetches filters
  * If false fetches notifications only and return it
  */


var fetchNotificationsData =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(store) {
    var fetchFilters,
        url,
        params,
        activeIMSOrg,
        locale,
        ansApiHeaders,
        response,
        errorMessage,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fetchFilters = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            url = new URL("".concat(_PulseApiHelper.default.getHostUrl(), "/ans/v1/notifications")); //TODO config_version has to be fetched from UACS

            params = {}, activeIMSOrg = '';

            if (fetchFilters) {
              // eslint-disable-next-line @typescript-eslint/camelcase
              params = {
                config_version: 0
              };
            } else {
              activeIMSOrg = NotificationsSelectors.getActiveIMSOrg(store.getState());
              locale = _PulseUtil.default.getNotificationsLocaleMapper(NotificationsSelectors.getLocale(store.getState()));
              params = {
                from: store.getState().notifications.serverTimestamp
              };
              params[Constants.IMS_ORG_PARAM] = activeIMSOrg;
              params[Constants.LOCALE] = locale;
            }

            ansApiHeaders = _PulseApiHelper.default.getDefaultHeaders();
            url.search = String(new URLSearchParams(params));
            response = {};
            _context.prev = 7;
            _context.next = 10;
            return fetch(url.href, {
              method: 'GET',
              headers: ansApiHeaders
            });

          case 10:
            response = _context.sent;

            if (!(!response || !response.ok)) {
              _context.next = 13;
              break;
            }

            throw new Error("Response not OK with Http status code ".concat(response.status));

          case 13:
            _context.next = 15;
            return response.json();

          case 15:
            _context.t0 = _context.sent;
            return _context.abrupt("return", {
              data: _context.t0
            });

          case 19:
            _context.prev = 19;
            _context.t1 = _context["catch"](7);

            /** fetch throws only with network error or to 4xx or 5xx error. This block also catches the error
             *  thrown when response is notOK from API, it that case we log the error status
             */
            //constuct custom errorResponse object
            errorMessage = {
              message: "Response not OK with Http status code ".concat(response.status),
              status: response.status
            };
            console.log("Error in shortpoll ".concat(_context.t1));
            metrics().event("exc.pulse.NotificationPolling.failed ".concat(_context.t1));
            return _context.abrupt("return", {
              error: errorMessage
            });

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 19]]);
  }));

  return function fetchNotificationsData(_x) {
    return _ref.apply(this, arguments);
  };
}();
/*
  * fetchConfigData(store) is to fetch filters and set them in store
  * currently being used in ViewAll
  */


exports.fetchNotificationsData = fetchNotificationsData;

var fetchConfigData =
/*#__PURE__*/
function () {
  var _ref2 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(store) {
    var response, payload;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchNotificationsData(store, true);

          case 2:
            response = _context2.sent;

            /* calling the parser display the filters and set the expected ansQueryFormat */
            // eslint-disable-next-line valid-typeof
            if (response && !response.error) {
              payload = _NotificationConfigParser.default.getFilters(response.data);
              /* Finally update the store with config param to udpate the filters list */

              store.dispatch({
                type: types.NOTIFICATION_FILTERS_FETCHED,
                payload: payload
              });
            }

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchConfigData(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchConfigData = fetchConfigData;
var _default = {
  fetchConfigData: fetchConfigData,
  fetchNotificationsData: fetchNotificationsData
};
exports.default = _default;